import { render, staticRenderFns } from "./assignedpermission.vue?vue&type=template&id=6c65123d&scoped=true"
import script from "./assignedpermission.vue?vue&type=script&lang=js"
export * from "./assignedpermission.vue?vue&type=script&lang=js"
import style0 from "./assignedpermission.vue?vue&type=style&index=0&id=6c65123d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65123d",
  null
  
)

export default component.exports